import React, {
  createContext,
  useCallback,
  useContext,
  useState
} from 'react';

export const MeetListContext = createContext(
  {},
);

export const MeetListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      committee: undefined,
      status: [],
      startDate: null,
      endDate: null,
      keyword: '',
      roundRobin: undefined,
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions(oldValue => ({
      ...oldValue,
      filterParams: params
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions(oldValue => ({
      ...oldValue,
      pagination: paginationOption
    }));
  }, []);

  return (
    <MeetListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </MeetListContext.Provider>
  );
};

export function useMeetList() {
  const context = useContext(MeetListContext);

  if (!context) {
    throw new Error('useMeetList must be used within an MeetListProvider.');
  }

  return context;
}
